import { createFileRoute } from "@tanstack/react-router";
import { CABINET_HOME_COPY } from "@/components/partners/cabinet-home-copy";
import { tutorCabinetHead } from "@/components/partners/tutor-cabinet-head";
import { TutorCabinetEditPage } from "@/components/partners/TutorCabinetPage";

// «Изменить анкету» (ru) — отдельный экран кабинета. «_» после me — не вкладывать
// в главную кабинета: у неё нет <Outlet/>. noindex, в sitemap нет.
export const Route = createFileRoute("/ru/tutors/me_/edit")({
  head: () => tutorCabinetHead("ru", CABINET_HOME_COPY.ru.editTitle),
  component: () => <TutorCabinetEditPage lang="ru" />,
});
